"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function imageNominalToUrl(source) {
  return `/api/imageAsset/${source.target.projectId}/${source.target.baseId}.${source.extension}`;
}

const Image = ({
  source,
  ...others
}) => {
  const src = typeof source === "object" ? imageNominalToUrl(source) : typeof source === "string" ? source : "/images/image-placeholder.svg";
  return _react.default.createElement("img", _extends({
    src: src,
    alt: (source === null || source === void 0 ? void 0 : source.name) || "",
    width: source === null || source === void 0 ? void 0 : source.width,
    height: source === null || source === void 0 ? void 0 : source.height
  }, others));
};

exports.Image = Image;
//# sourceMappingURL=Image.js.map